"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _menu = require("../../utils/menu");
var _Dropdown = require("./Dropdown");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SimpleDropdownBase = (props, ref) => {
  const {
    size = 'medium',
    classNames,
    placeholder = 'Select...',
    options,
    optionsVariant,
    allowSearch,
    selectedKeys,
    onChange,
    onMenuOpen,
    onMenuClose,
    resolveLabel,
    elevation = 'modal',
    menuVirtualization,
    resolveSecondaryLabel,
    isMenuFluid = true,
    header,
    footer,
    menuClassNames,
    showLabelTooltip,
    clickAwayRef,
    allowWrap = false,
    staticLabels,
    testId,
    ...inputProps
  } = props;
  const [dropdownInputText, setDropdownInputText] = React.useState('');
  const [dropdownSelectedKeys, setDropdownSelectedKeys] = React.useState(selectedKeys);
  React.useEffect(() => {
    const newDropdownText = (0, _menu.getTextLabelFromSelectedKeys)(selectedKeys, options);
    setDropdownSelectedKeys(selectedKeys);
    setDropdownInputText(newDropdownText);
  }, [selectedKeys]);
  const handleOptionChange = (selectedOption, e) => {
    e?.stopPropagation();
    let newSelectedKeys = [];
    if (optionsVariant === 'checkbox') {
      newSelectedKeys = (0, _menu.getSelectedKeysFromSelectedOption)(selectedOption, dropdownSelectedKeys);
    } else {
      newSelectedKeys = [selectedOption.key];
    }
    const newDropdownText = (0, _menu.getTextLabelFromSelectedKeys)(newSelectedKeys, options);
    setDropdownSelectedKeys(newSelectedKeys);
    setDropdownInputText(newDropdownText);
    setTimeout(() => {
      onChange?.(selectedOption, e);
    });
  };
  React.useImperativeHandle(ref, () => ({
    selectedKeys: dropdownSelectedKeys
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Dropdown, {
    ...inputProps,
    classNames: classNames,
    size: size,
    elevation: elevation,
    placeholder: placeholder,
    onChange: handleOptionChange,
    onMenuOpen: onMenuOpen,
    onMenuClose: onMenuClose,
    dropdownInputText: dropdownInputText,
    clickAwayRef: clickAwayRef,
    testId: testId,
    menu: {
      options,
      selectedKeys: dropdownSelectedKeys,
      optionsVariant,
      allowSearch,
      resolveLabel,
      resolveSecondaryLabel,
      virtualization: menuVirtualization,
      size,
      isFluid: isMenuFluid,
      header,
      footer,
      classNames: menuClassNames,
      showLabelTooltip,
      allowWrap,
      staticLabels
    }
  });
};
const SimpleDropdown = exports.SimpleDropdown = /*#__PURE__*/React.forwardRef(SimpleDropdownBase);